import { useEffect, useState } from 'react';

import { SearchFieldsType } from '../types/MovimentacaoFundosType';

export const SearchFields = ({
  clearFields,
  setCurrentPage,
  name,
  setName,
  cpf,
  setCpf,
  offer,
  setOffer,
  handleSearchClient
}: SearchFieldsType) => {
  const [isBtnFiltrarDisabled, setBtnFiltrarDisabled] = useState(true);
  const [isBtnLimparFiltrosDisabled, setBtnLimparFiltrosDisabled] =
    useState(true);

  const handleIsDisable = () => {
    if (name?.trim() || cpf?.trim() || offer?.trim()) {
      setBtnFiltrarDisabled(false);
    } else {
      setBtnFiltrarDisabled(true);
    }
  };

  const handleIsClearFields = () => {
    setName('');
    setCpf('');
    setOffer('');
  };

  useEffect(() => {
    handleIsDisable();
  }, [name, cpf, offer]);

  useEffect(() => {
    handleIsClearFields();
  }, [clearFields]);

  return (
    <div className="tw-w-full tw-flex tw-justify-between tw-items-center tw-space-x-4">
      <div className="tw-w-full tw-flex tw-items-center tw-space-x-4">
        <p className="tw-text-gray-700">Filtrar:</p>
        <input
          type="text"
          placeholder="Nome"
          className="tw-w-40 tw-px-3 tw-py-2 tw-border tw-rounded-md tw-shadow-sm tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500 tw-focus:border-blue-500"
          value={name}
          onChange={(event) => {
            setName(event.target.value);
            setCpf('');
            setOffer('');
          }}
        />
        <input
          type="text"
          placeholder="CPF"
          className="tw-w-40 tw-px-3 tw-py-2 tw-border tw-rounded-md tw-shadow-sm tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500 tw-focus:border-blue-500"
          value={cpf}
          onChange={(event) => {
            const numericValueCpf = event.target.value.replace(/\D/g, '');
            setName('');
            setCpf(numericValueCpf);
            setOffer('');
          }}
        />
        <input
          type="text"
          placeholder="Proposta"
          className="tw-w-40 tw-px-3 tw-py-2 tw-border tw-rounded-md tw-shadow-sm tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500 tw-focus:border-blue-500"
          value={offer}
          onChange={(event) => {
            const numericValueOffer = event.target.value.replace(/\D/g, '');
            setName('');
            setCpf('');
            setOffer(numericValueOffer);
          }}
        />
      </div>
      <button
        data-testid="btn-filter"
        className={`${
          isBtnFiltrarDisabled
            ? 'tw-bg-orange-200 tw-cursor-not-allowed'
            : 'tw-bg-[#FA6B25] tw-cursor-pointer'
        } tw-w-40 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-focus:outline-none tw-focus:shadow-outline tw-flex tw-items-center tw-justify-center tw-space-x-2 tw-rounded-md`}
        onClick={() => {
          setCurrentPage(1);
          handleSearchClient(5, 0, name, cpf, offer);
          setBtnLimparFiltrosDisabled(false);
        }}
        disabled={isBtnFiltrarDisabled}
      >
        <p>Filtrar</p>
      </button>
      <button
        data-testid="btn-clear-filters"
        className={`${
          isBtnLimparFiltrosDisabled
            ? 'tw-bg-gray-200 tw-cursor-not-allowed'
            : 'tw-bg-[#ACACAC] tw-cursor-pointer'
        } tw-w-48 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-focus:outline-none tw-focus:shadow-outline tw-flex tw-items-center tw-justify-center tw-space-x-2 tw-rounded-md`}
        onClick={() => {
          setCurrentPage(1);
          setName('');
          setCpf('');
          setOffer('');
          handleSearchClient(5, 0, '', '', '');
          setBtnLimparFiltrosDisabled(true);
        }}
        disabled={isBtnLimparFiltrosDisabled}
      >
        <p>Limpar Filtros</p>
      </button>
    </div>
  );
};
